<template>
  <div id="wrapper">
    <TextHeader header-title="Contact" />
    <div class="w-container">
      <SectionHeader text="Contact" show-back-text="true" />
      <div class="contact-item">
        <div
          class="contact-icon"
          :style="{
            backgroundImage: 'url(' + require('../assets/images/mail.svg'),
          }"
        ></div>
        <div class="contact-value" id="email">office@madrigal.ro</div>
      </div>
      <div class="contact-item">
        <div
          class="contact-icon"
          :style="{
            backgroundImage: 'url(' + require('../assets/images/phone.svg'),
          }"
        ></div>
        <div class="contact-value" id="phone">+40 21 312 65 57</div>
      </div>
      <div class="contact-item">
        <div
          class="contact-icon"
          :style="{
            backgroundImage: 'url(' + require('../assets/images/map.svg'),
          }"
        ></div>
        <div class="contact-value" id="address">
          Aleea Dealul Mitropoliei, nr. 11, Sector 4, Bucuresti.
        </div>
        <GmapMap
          :center="{ lat: 44.4250408, lng: 26.0983143 }"
          :zoom="16"
          map-type-id="terrain"
          style="width: 100%; height: 300px"
          class="map"
        >
          <GmapMarker
            :position="{ lat: 44.4250408, lng: 26.0983143 }"
            :clickable="false"
            :draggable="false"
          />
        </GmapMap>
      </div>
    </div>
  </div>
</template>

<script>
import TextHeader from "./TextHeader";
import SectionHeader from "./SectionHeader";

export default {
  name: "Contact",
  components: { SectionHeader, TextHeader },
};
</script>

<style scoped>
#wrapper {
  min-height: 80vh;
}

.contact-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 57px;
  padding-bottom: 57px;
  border-top: 1px solid #cacaca;
}

.contact-item:last-child {
  border-bottom: 1px solid #cacaca;
}

.contact-icon {
  width: 50px;
  height: 90px;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 45px;
}

.contact-value {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 1.7em;
  font-weight: 400;
}
</style>
